export default __webpack_public_path__ + "static/media/AmorNutre.e478e921.png";